module.exports = __webpack_public_path__ + "static/media/pos-icon.2f850b89.png";